<template>
  <div>
    <el-card>
      <div class="block">
        <el-form :inline="true">
          <el-form-item label="日期">
            <el-date-picker
                v-model="dateRange"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="平台账号:">
            <el-select v-model="exchange" placeholder="请选择平台账号">
              <el-option v-for="item in hedgeAccountEnum" :key="item.key" :value="item.key" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种类型:">
            <!--            <el-input v-model="coinType" placeholder="请输入币种类型"></el-input>-->
            <el-autocomplete popper-class="my-autocomplete" v-model="coinType" :fetch-suggestions="querySearch" placeholder="请输入币种类型" @select="handleSelect">
              <i class="el-icon-edit el-input__icon" slot="suffix" @click="handleIconClick"></i>
              <template slot-scope="{ item }"><div class="name">{{ item.value }}</div></template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryHedgeHistoryDepositWithdraw">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="top" v-if="isShow">
          <el-table :data="tableData" style="width: 100%" max-height="1000" border>
            <el-table-column prop="exchange" label="对冲账号" width="110" sortable></el-table-column>
            <el-table-column prop="coin" label="币种类型" width="110" sortable></el-table-column>
            <el-table-column prop="direction" label="方向" width="110" sortable></el-table-column>
            <el-table-column prop="amount" label="数量" width="80" sortable></el-table-column>
            <el-table-column prop="tradeId" label="交易ID" sortable></el-table-column>
            <el-table-column prop="depositAddr" label="充值地址" sortable></el-table-column>
            <el-table-column prop="withdrawAddr" label="提现地址" sortable></el-table-column>
            <el-table-column prop="state" label="状态" width="120" sortable></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" sortable></el-table-column>
          </el-table>
          <el-pagination background
                         layout="total, sizes, prev, pager, next, jumper"
                         :page-size="pageSize"
                         :page-sizes="[1, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
                         :total="total"
                         :current-page="currentPageNum"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange">
          </el-pagination>
          <div style="text-align:right">
            <el-button type="success" plain @click="exportExcel()">导出excel</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store'
import {mapState} from "vuex";
import utils from "@/entries/HedgeCenter/BalanceBook/utils";

const columns=[
  {title:'对冲账号',key:'exchange'},
  {title:'币种类型',key:'coin'},
  {title:'方向',key:'direction'},
  {title:'数量',key:'amount'},
  {title:'交易ID',key:'tradeId'},
  {title:'充值地址',key:'depositAddr'},
  {title:'提现地址',key:'withdrawAddr'},
  {title:'状态',key:'state'},
  {title:'创建时间',key:'createTime'}
]

export default {
  name: "DepositWithdraw",
  data(){
    return {
      pages:0,
      total:0,
      buffer:'',
      currentPageNum:1,
      pageSize:20,
      isShow:false,
      exchange:'',
      coinType: '',
      activeName:'part1',
      dateRange:[],
      tableData:[],
      restaurants:[],
    }
  },
  methods:{

    handleSizeChange(val){
      this.params.pageSize = val
      this.queryHedgeHistoryDepositWithdraw()
    },

    handleCurrentChange(val) {
      this.params.pageNum = val
      this.queryHedgeHistoryDepositWithdraw()
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },

    handleSelect(item) {},
    handleIconClick(ev) {},

    queryHedgeHistoryDepositWithdraw (){
      if (this.dateRange.length === 0){
        this.$message.error("请选择日期")
        return
      }
      if (this.exchange === ""){
        this.$message.error("请选择平台账号")
        return
      }
      if (this.buffer === ''){
        this.buffer = this.paramsBak
      } else {
        if (this.buffer !== this.paramsBak){
          this.params.pageNum = 1
          this.buffer = this.paramsBak
        }
      }
      utils.pageQueryHedgeHistoryDepositWithdraw(this.params).then((response=>{
        this.isShow = true
        this.total = response.data.total
        this.pages = response.data.pages
        this.pageSize = response.data.size
        this.currentPageNum = response.data.current
        let tableData = response.data.records
        for (let key in tableData){
          tableData[key].createTime = utils.getLocalTime(tableData[key].createTime)
          tableData[key].updateTime = utils.getLocalTime(tableData[key].updateTime)
        }
        this.tableData = tableData
      }))
    },

    exportExcel (){
      utils.allQueryHedgeHistoryDepositWithdraw(this.params).then((response=>{
        let startTime = utils.getLocalTime(this.dateRange[0])
        let endTime = utils.getLocalTime(this.dateRange[1])
        let title = '历史充提明细' + startTime + '-' + endTime
        let data = response.data
        for (let key in data){
          data[key].createTime = utils.getLocalTime(data[key].createTime)
          data[key].updateTime = utils.getLocalTime(data[key].updateTime)
        }
        utils.export2Excel(columns, data, title)
      }))
    }

  },
  computed: {
    ...mapState('balanceReconciliation', ['hedgeAccountEnum', 'pickerOptions']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        coinType: this.coinType,
        exchange: this.exchange,
        pageSize: this.pageSize,
        pageNum: this.currentPageNum
      };
    },
    paramsBak() {
      return {
        dateRange:this.dateRange,
        coinType: this.coinType,
        exchange: this.exchange,
      };
    },
  },
  created() {
  }
}
</script>

<style scoped>

</style>